"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// src/jsx/ChevronDown.tsx
function ChevronDown(props) {
  return /* @__PURE__ */ React__namespace.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ...props
  }, /* @__PURE__ */ React__namespace.createElement("path", {
    fillRule: "evenodd",
    d: "M2.253 7.336a1 1 0 011.411-.083L12 14.662l8.336-7.41a1 1 0 011.328 1.495l-9 8a1 1 0 01-1.328 0l-9-8a1 1 0 01-.083-1.411z",
    clipRule: "evenodd"
  }));
}
var ChevronDown_default = ChevronDown;

exports.ChevronDown_default = ChevronDown_default;
